import { connect } from 'react-redux';

import defaultBrandLogoFooter from 'themes/[theme]/assets/images/brand-logo-alternative.png';
import Footer from '../components/Footer';

export default connect(

  state => {
    const copyrightText = state.externalisedStrings['footers.footer.copyrightRaven'];
    return ({
      ...state.footer,
      copyrightText,
      footerLogo: getFooterLogo(state),
    });
  }
)(Footer);

function getFooterLogo(state) {
  const { footerLogo } = state.logosFromScribe;
  const shouldUseScribeLogo = state.user.betaFeatures.includes('SCRIBE_LOGO');

  const defaultLogo = {
    image: defaultBrandLogoFooter,
    altText: 'footer logo',
  };

  if (!footerLogo || !footerLogo.image) return defaultLogo;

  const scribeLogo = { ...footerLogo };

  return shouldUseScribeLogo ? scribeLogo : defaultLogo;
}
